<template>
	<div class="answerType">
		<!-- 응답내장형 입력 -->
		<div class="mgt-24" v-if="data.type === 'INPUT'">
			<label
					class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46  mdc-text-field--disabled disabled--Updated"
					data-mdc-auto-init="MDCTextField">
					<span class="mdc-notched-outline">
									<span class="mdc-notched-outline__leading"></span>
									<!-- <span class="mdc-notched-outline__notch">
													<span class="mdc-floating-label" id="my-label-id">{{$t('1256')}}</span>
									</span> -->
									<span class="mdc-notched-outline__trailing"></span>
					</span>
					<input class="mdc-text-field__input t-body6 font-r z-99"
							type="text"
							maxlength="50"
							autocomplete="off"
							v-model="text"
							readonly disabled/>
			</label>
		</div>
		<!-- 응답내장형 선택 -->
		<div class="mgt-24" v-if="data.type === 'SELECT'">
				<div class="mdc-select mdc-select--outlined w-full mdc--select__custom mdc-select--disabled"
							data-mdc-auto-init="MDCSelect">
						<div class="mdc-select__anchor h-46" aria-labelledby="outlined-select-label">
							<span class="mdc-notched-outline">
								<span class="mdc-notched-outline__leading"></span>
								<span class="mdc-notched-outline__notch">
												<!-- <span id="outlined-select-label"
																class="mdc-floating-label t-body6 t-color-textfieldGuid font-r">	{{$t('1255')}}</span> -->
								</span>
								<span class="mdc-notched-outline__trailing"></span>
							</span>
							<select class="mdc-select__native-control w-full mgt-8 mgr-8"
								v-model="text" >
									<option  value="" disabled> {{$t('1255')}} </option>
									<option v-for="(view, index) in data.views" :value="index" :key="index" disabled>{{view}}</option>
								</select>
						</div>
				</div>
		</div>
	</div>

</template>

<script>
/**
 * 응답내장형 문항 피드백 INPUT/SELECT 컴포넌트(fill in the blank question feedback INPUT/SELECT component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCSelect} from '@material/select'

export default {
	props: ['data', 'itemIndex', 'setedAnswer'],

	data() {
		return {
			text: ''
		}
	},

	watch: {
    setedAnswer(newVar, oldVar) {
      this.text = JSON.parse(JSON.stringify(this.setedAnswer))
      this.$nextTick(() => {
        // this.$refs.inputType.focus()
        if(document.querySelector('.mdc-text-field')) {
          const textField = new MDCTextField(document.querySelector('.mdc-text-field'))
          textField.value = this.text
        }
      })
    }
  },

	mounted() {
		this.text = this.setedAnswer
		if (this.data.type === 'INPUT') {
			const textField = new MDCTextField(document.querySelector('.mdc-text-field'))
			textField.value = this.text
		}

		if (this.data.type === 'SELECT') {
			const select = new MDCSelect(document.querySelector('.mdc-select'))
		}

	},
}

</script>
<style scoped>
.mdc-select-control-custom{
	border-radius: 4px;
	padding-top: 10px;
}
</style>
